import React, { Fragment, useContext, useEffect, useState } from "react";
import { listOfThreeWeeks } from "../lib/dateCalculate";
import { dateNow } from "../utils/dateUtils";
import { TZ } from "../utils/dateUtils";
import ja from "dayjs/locale/ja";
import { Box, Container, Grid } from "@material-ui/core";
import SectionHeader from "./SectionHeader";
import { UserDataContext } from "../context/UserDataContext";

interface DateInfo {
  date: string;
  year: string;
  dayName: string;
  week: string;
  month: string;
  day;
}

function CalendarComponent() {
  const { businessHolidayData, supportTicketData } =
    useContext(UserDataContext);
  const daysOfWeek = ["日", "月", "火", "水", "木", "金", "土"];
  const [calendarData, setCalendarData] = useState<any | undefined>(undefined);
  useEffect(() => {
    if (businessHolidayData) {
      const data = makeCalendar();
      setCalendarData(data);
    }
  }, [businessHolidayData, supportTicketData]);
  function makeCalendar() {
    const today = dateNow();
    const calendarData: DateInfo[] = addHolidays();
    const todayObj: any = calendarData[0];
    var thisMonth: any[] = [];
    var nextMonth: any[] = [];
    for (var i = 0; i < calendarData.length; i++) {
      if (today.tz(TZ.JST).locale(ja).format("M") == calendarData[i].month) {
        if (calendarData[i].year == todayObj.year) {
          for (var d = 0; d < parseInt(todayObj.week); d++) {
            thisMonth.push(null);
          }
        }

        thisMonth.push(calendarData[i]);
      } else {
        nextMonth.push(calendarData[i]);
      }
    }
    if (nextMonth.length && parseInt(nextMonth[0]?.week) != 0) {
      var weekNumber = parseInt(nextMonth[0].week);
      for (var d = 0; d < weekNumber; d++) {
        nextMonth.unshift(null);
      }
    }
    return {
      thisMonthNumb: today.tz(TZ.JST).locale(ja).format("M"),
      nextMonthNumb: today.tz(TZ.JST).locale(ja).add(1, "month").month() + 1,
      today: todayObj.day,
      thisMonth,
      nextMonth,
    };
  }
  function addHolidays() {
    const data = listOfThreeWeeks();
    const holidays = businessHolidayData && businessHolidayData.businnesHoliday;
    if (holidays && holidays.length) {
      for (const obj1 of holidays) {
        for (const obj2 of data) {
          if (obj1.ymd === obj2.dateYear) {
            obj2.isHoliday = true;
            break; // No need to continue checking once a match is found
          }
        }
      }
    }
    const reservations =
      supportTicketData && supportTicketData.supportTicketList;
    if (reservations && reservations.length) {
      for (const obj1 of reservations) {
        for (const obj2 of data) {
          const reservationYMD = obj1.reservationTime.split("-")[1];
          if (
            parseInt(reservationYMD) == obj2.dateYear &&
            obj1.amountRefunded == undefined
          ) {
            obj2.isReservation = true;
            break;
          }
        }
      }
    }
    return data;
  }
  return (
    <Box className="section bg-dots">
      {calendarData && (
        <Container className="container">
          <SectionHeader currentPage={"カレンダー"} preHeading={"Calendar"} />
          <Box className="calender-wrapper">
            <Grid container alignItems="center">
              <Grid item xs={2} sm={2}></Grid>
              <Grid item xs={10} sm={10}>
                <Grid
                  container
                  style={{ marginBottom: "1.8rem", marginTop: "2rem" }}
                  className="text-center"
                >
                  {daysOfWeek.map((weekName, id) => (
                    <div key={id} className="calendar-week">
                      <span>{weekName}</span>
                    </div>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={2} sm={2} className="text-center">
                <div className="month-name">{calendarData.thisMonthNumb}月</div>
              </Grid>
              <Grid item xs={10} sm={10}>
                <Grid container className="text-center">
                  {calendarData.thisMonth.map((date, id) => (
                    <div
                      key={id}
                      className={`calendar-dates ${
                        date?.isReservation ? "date-reservation" : ""
                      } ${date?.isHoliday ? "date-holiday" : ""}`}
                    >
                      <span>{date ? date.day : ""}</span>
                    </div>
                  ))}
                </Grid>
              </Grid>
              {calendarData.nextMonth.length > 0 && (
                <Fragment>
                  <Grid item xs={2} sm={2} className="text-center">
                    <div className="month-name">
                      {calendarData.nextMonthNumb}月
                    </div>
                  </Grid>
                  <Grid item xs={10} sm={10}>
                    <Grid container className="text-center next-month-dates">
                      {calendarData.nextMonth.map((date, id) => (
                        <div
                          key={id}
                          className={`calendar-dates ${
                            date?.isHoliday ? "date-holiday" : ""
                          } ${date?.isReservation ? "date-reservation" : ""}`}
                        >
                          <span>{date ? date.day : ""}</span>
                        </div>
                      ))}
                    </Grid>
                  </Grid>
                </Fragment>
              )}
              <Grid item xs={2} sm={3}></Grid>
              <Grid
                item
                xs={10}
                sm={9}
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={"auto"}>
                  <div className="calendar-info">
                    <span className="pink-dot"></span>
                    サービス休業日
                  </div>
                </Grid>
                <Grid item xs={"auto"}>
                  <div className="calendar-info">
                    <span className="blue-dot"></span>
                    サポート予約日
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}
    </Box>
  );
}

export default CalendarComponent;
